/**
 * External Dependencies
 */
import 'jquery';

$(document).ready(() => {

  $('.hamburger').click(function() {
    $(this).toggleClass('is-active');
    $('#combined-navigation').toggleClass('is-active');
  });
});
